import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallbackPage() {
  const { exchangeGoogleSession } = useAuth();
  const nav = useNavigate();
  const hasProcessed = useRef(false);
  const [msg, setMsg] = useState("Signing you in with Google…");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      toast.error("Missing session id");
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await exchangeGoogleSession(sessionId);
        // Clear the hash so we don't re-trigger
        window.history.replaceState(null, "", window.location.pathname);
        if (res?.new_user) {
          toast.success(res?.bonus_credits
            ? `Welcome ${res.name}! You got ${res.bonus_credits} free reveals 🎁`
            : `Welcome to To-Let Rentals, ${res.name}!`);
        } else {
          toast.success(`Welcome back, ${res?.name || ""}!`);
        }
        nav("/dashboard", { replace: true });
      } catch (err) {
        console.error("Google auth exchange failed:", err);
        toast.error(err?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [exchangeGoogleSession, nav]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center" data-testid="auth-callback">
        <Loader2 size={32} className="animate-spin text-[#7A1E2A] mx-auto mb-4" />
        <p className="font-display text-xl text-[#7A1E2A]">{msg}</p>
        <p className="text-sm text-gray-500 mt-2">Please wait a moment…</p>
      </div>
    </div>
  );
}
